import type { ComponentProps } from 'react';

import { CheckSquareIcon, XSquareIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * Props for the AnswerCorrectToggle component.
 * @property correct - Indicates if the answer is marked as correct.
 * @property onCorrectChange - Callback fired when the correct state changes.
 */
interface AnswerCorrectToggleProps extends ComponentProps<typeof Button> {
  correct: boolean;
  onCorrectChange: (correct: boolean) => void;
}

export function AnswerCorrectToggle(answerCorrectToggleProps: AnswerCorrectToggleProps) {
  const { correct, onCorrectChange, ...props } = answerCorrectToggleProps;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button size={'sm'} variant={'outline'} type={'button'} aria-label={correct ? 'Mark answer as incorrect' : 'Mark answer as correct'} onClick={() => onCorrectChange(!correct)} {...props}>
          {correct ? <CheckSquareIcon className={'stroke-text-success!'} /> : <XSquareIcon className={'stroke-text-destructive!'} />}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{correct ? 'Odpowiedź zaznaczona jako poprawna' : 'Odpowiedź zaznaczona jako niepoprawna'}</TooltipContent>
    </Tooltip>
  );
}
